// extracted by mini-css-extract-plugin
export default {"form":"Form_form__Tpjcd","form__input":"Form_form__input__AyiMO","form__submit":"Form_form__submit__+DfW1","form__action-scroll":"Form_form__action-scroll__j4POe"};